export const bn = {
    // Header
    'header.title': '🎭 কিন উন্মোচিত',
    'header.subtitle': 'Tom Kean Jr. (NJ-7) — আপনার স্বাস্থ্যসেবার পরোয়া করেন না।',

    // Hero Section
    'hero.quote': 'Tom Kean Jr.: "আমি ভোটারদের বলি আমি স্বাধীন। তারপর MAGA-এর সাথে ভোট দিই।"',
    'hero.subtext': '৪ জন রিপাব্লিকান ACA ভর্তুকি বাঁচাতে দল থেকে বেরিয়ে এসেছে। ১৭ই ডিসেম্বর, ৪ জন GOP আইনপ্রণেতা সাহস দেখিয়েছেন এবং ভোট জোর করতে ডেমোক্র্যাটদের সাথে যুক্ত হয়েছেন। Tom Kean Jr. (NJ-7)? তিনি চুপ ছিলেন। ডিসেম্বরে, কিয়ান ACA ভর্তুকি বাড়ানোর জন্য ১৭ জন রিপাব্লিকান সিনেটরের সঙ্গে GOP-এর আহ্বানে নিজের নাম যোগ করেছিলেন—তবু তিনি হাউস রিপাবলিকানদের সাথে মিলে সেই সম্প্রসারণ ঠেকাতে ভোট দিয়েছেন। ২২ মিলিয়ন আমেরিকান ১লা জানুয়ারি থেকে ১১৪% প্রিমিয়াম বৃদ্ধির সম্মুখীন।',

    // Breaking News
    'breaking.news': '🚨 ব্রেকিং: CNN: আমেরিকানরা স্বাস্থ্যসেবায় আগের চেয়ে বেশি খরচ করছে',

    // Kean Did Not Support Section
    'kean.betrayal.title': 'TOM KEAN JR. আপনার পক্ষে দাঁড়াতে অস্বীকার করেছেন',
    'kean.betrayal.text': '১৭ই ডিসেম্বর, প্রতিদ্বন্দ্বী জেলা থেকে ৪ জন রিপাব্লিকান (Brian Fitzpatrick, Rob Bresnahan Jr., Ryan Mackenzie PA থেকে, এবং Mike Lawler NY থেকে) তাদের দলের বিরুদ্ধে গিয়ে ACA ভর্তুকি বর্ধনে ভোট জোর করতে ডেমোক্র্যাটদের সাথে যোগ দিয়েছেন। প্রতিনিধি Tom Kean Jr. (NJ-7) তাদের মধ্যে ছিলেন না। তিনি আপনার স্বাস্থ্যসেবার বদলে দলের প্রতি আনুগত্য বেছে নিয়েছেন।',
    'kean.betrayal.comparison': 'এই ৪ জন রিপাব্লিকান সাহস দেখিয়েছেন। কিন কাপুরুষতা দেখিয়েছেন।',
    'kean.betrayal.cta': 'কিনকে জিজ্ঞেস করুন: কেন আমাদের পক্ষে দাঁড়ালেন না?',

    // Healthcare Context Section
    'context.title': 'রিপাবলিকানরা আপনার স্বাস্থ্যসেবার পরোয়া করে না: "স্বাস্থ্য ব্যয়ের সুনামি" এখন সামনে',
    'context.intro': 'রিপাবলিকান কংগ্রেসম্যান Tom Kean Jr. (NJ-7) আপনার স্বাস্থ্যসেবার জন্য কিছুই করেননি। প্রিমিয়াম, ডাক্তারের ভিজিট, প্রেসক্রিপশন — সবকিছুর জন্য বেশি অর্থ প্রদানের জন্য প্রস্তুত হন। আপনি এটা কীভাবে বহন করবেন? ১৬ই ডিসেম্বর, হাউস রিপাবলিকানরা ACA ভর্তুকি বর্ধনের জন্য ডেমোক্র্যাটদের প্রচেষ্টা প্রত্যাখ্যান করেছে। ডেমোক্র্যাটরা আপনার স্বাস্থ্যসেবার জন্য লড়াই করে আসছে — ACA পাস করা, প্রধান ওষুধের দাম কমানো, এবং আরও অনেক কিছু। কিন্তু Tom Kean Jr. তার দলের সাথে ভোট দিয়েছে এই সুরক্ষাগুলি মেয়াদ শেষ হতে দিতে।',
    'context.truth.title': 'সত্য: NJ পরিবারের উপর প্রকৃত প্রভাব',
    'context.truth.text': 'NJ-এর মাহওয়াহ বাসিন্দা Tina Jump জানতে পেরেছেন তার ACA প্রিমিয়াম <strong>মাসে $400 থেকে $1,100-এর বেশি</strong>তে বাড়বে — প্রায় তিনগুণ বৃদ্ধি। "আমি জানি না কীভাবে এটা দেব," তিনি CBS News-কে বলেছিলেন।',
    'context.impact': 'ট্যাক্স ক্রেডিটের জন্য যোগ্য <strong>২২ মিলিয়ন আমেরিকান</strong> এখন কঠিন আর্থিক সিদ্ধান্তের সম্মুখীন। নিজের পকেট থেকে প্রিমিয়াম খরচ <strong>গড়ে ১১৪% বাড়বে</strong>, বার্ষিক খরচ $1,016 বাড়বে। বছরে $75,000 উপার্জনকারী চার সদস্যের পরিবার অতিরিক্ত <strong>$3,368</strong> প্রিমিয়াম বৃদ্ধি দেখতে পারে।',
    'context.tsunami': '"আমরা ১লা জানুয়ারি স্বাস্থ্য ব্যয় বৃদ্ধির একটি সুনামি দেখতে যাচ্ছি," Community Catalyst-এর Michelle Sternthal বলেছেন। কংগ্রেশনাল বাজেট অফিসের মতে, উচ্চ প্রিমিয়ামের কারণে প্রায় <strong>৪ মিলিয়ন মানুষ তাদের স্বাস্থ্য বীমা ছেড়ে দিতে</strong> পারে।',
    'context.exposed.title': 'উন্মোচিত: সবচেয়ে ঝুঁকিপূর্ণ কারা?',
    'context.exposed.text': 'ছোট ব্যবসার মালিক এবং স্ব-নিযুক্ত কর্মীরা বিশেষভাবে ঝুঁকিতে আছেন। ACA-তে নথিভুক্ত প্রাপ্তবয়স্কদের প্রায় অর্ধেক ছোট ব্যবসার মালিক, ২৫ জনের কম কর্মী সহ কোম্পানিতে নিযুক্ত, বা স্ব-নিযুক্ত।',
    'context.accountability': 'প্রতিনিধি Tom Kean Jr. (NJ-7) তার দলের সাথে এই ভর্তুকি মেয়াদ শেষ হতে দেওয়ার জন্য ভোট দিয়েছেন। কংগ্রেশনাল ডেমোক্র্যাটরা ACA প্রিমিয়াম ট্যাক্স ক্রেডিট বর্ধনে ভোট জোর করার জন্য একটি ডিসচার্জ পিটিশন প্রচার করছে। হাউস জেতার পথ সরাসরি নিউ জার্সির মধ্য দিয়ে যায়। তাকে জবাবদিহি করার সময় এসেছে।',
    'context.cta': 'এখনই পদক্ষেপ নিন',

    // ACA Section
    'aca.title': 'রিপাবলিকানরা আপনার স্বাস্থ্যসেবা কেড়ে নিচ্ছে — ACA ভর্তুকি ৩১শে ডিসেম্বর শেষ হয়েছে',
    'aca.text': 'হাউস রিপাবলিকানরা ১৬ই ডিসেম্বর ACA ভর্তুকি বর্ধন অবরুদ্ধ করেছে। ১লা জানুয়ারি থেকে, প্রিমিয়াম গড়ে ১১৪% বাড়বে। কিছু পরিবার, যেমন বছরে $72,000 উপার্জনকারী একজন মাহওয়াহ বাসিন্দা, খরচ প্রায় তিনগুণ হবে — মাসে $400 থেকে $1,100-এর বেশি। প্রতিনিধি Tom Kean Jr. (NJ-7) এই জীবনরেখা অবরুদ্ধ করতে তার দলের সাথে ভোট দিয়েছেন।',
    'aca.chart.title': 'গড় প্রিমিয়াম বৃদ্ধি',
    'aca.chart.2025': '২০২৫',
    'aca.chart.2026': '২০২৬',
    'aca.chart.withSubsidies': 'ভর্তুকি সহ',
    'aca.chart.increase': '+১১৪% গড়',

    // No Kean Day Section
    'nokean.title': 'নো কিন ডে!',
    'nokean.date': '৭ই ফেব্রুয়ারি',
    'nokean.message': 'তাকে একটি বার্তা পাঠান!',
    'nokean.standup': 'স্বাস্থ্যসেবার জন্য দাঁড়ান',
    'nokean.handle': '@CongressmanKean',
    'nokean.caption': '"আয়না আমাকে অস্বস্তিতে ফেলে বলে টাউন হল এড়িয়ে চলি।"',

    // Voting Record Section
    'voting.title': '📜 রসিদ পরিষ্কার',
    'voting.record.title': 'Tom Kean Jr.-এর ভোটিং রেকর্ড',
    'voting.bill.name': 'H.R.1 - এক বিশাল সুন্দর বিল আইন',
    'voting.bill.congress': '১১৯তম কংগ্রেস (২০২৫-২০২৬) | পাবলিক ল ১১৯-২১',
    'voting.bill.rollcall': 'রোল কল ভোট #১৪৫ | ২২শে মে, ২০২৫',
    'voting.bill.cut1': '• ACA ভর্তুকি কাটছে - ১৭৪% প্রিমিয়াম বৃদ্ধি ঘটাচ্ছে',
    'voting.bill.cut2': '• NJ পরিবারকে প্রভাবিত করে মেডিকেইড তহবিল কমাচ্ছে',
    'voting.breakdown.title': 'ভোট বিশ্লেষণ',
    'voting.breakdown.yeas': '✓ হ্যাঁ: ২১৫ (সব রিপাবলিকান)',
    'voting.breakdown.nays': '✗ না: ২১৪ (সব ডেমোক্র্যাট)',
    'voting.breakdown.present': 'উপস্থিত: ১',
    'voting.breakdown.notvoting': 'ভোট দেয়নি: ২',
    'voting.breakdown.passed': 'পাস',
    'voting.kean.name': 'TOM KEAN JR.',
    'voting.kean.title': 'প্রতিনিধি, NJ-7',
    'voting.kean.vote': 'হ্যাঁ',
    'voting.kean.result': 'স্বাস্থ্যসেবা কাটতে ভোট দিয়েছেন',
    'voting.source': 'সূত্র: মার্কিন প্রতিনিধি পরিষদের ক্লার্ক অফিস | clerk.house.gov/Votes/2025145',
    'voting.cta.vote': 'Kean-এর ভোট দেখুন',
    'voting.cta.bill': 'বিল পড়ুন (H.R.1)',

    // Medicaid Section
    'medicaid.title': 'Tom Kean Jr.: "আমি এটাকে \'আর্থিক দায়িত্ব\' বলি"',
    'medicaid.text': 'প্রতিনিধি Tom Kean Jr. (NJ-7) মেডিকেইড কাটার সমর্থন করেছেন যা বয়স্ক, শিশু এবং প্রতিবন্ধী মানুষদের হুমকি দেয়। এই কাটা ডাক্তার, হাসপাতাল এবং দীর্ঘমেয়াদী যত্নে প্রবেশাধিকার কমায়। প্রতিটি ভোট সত্য বলে — এমনকি তিনি না বললেও।',
    'medicaid.visual': 'মেডিকেইড = জীবনরেখা',
    'medicaid.hashtags': '#কিনউন্মোচিত #টাকারপিছনেছুটুন',
    'medicaid.hashtags.text': '#কিনউন্মোচিত #টাকারপিছনেছুটুন #রিপাবলিকানরাস্বাস্থ্যেরপরোয়াকরেনা',

    // Medicare Section
    'medicare.title': 'Tom Kean Jr.: "আমি আমার কণ্ঠ হারাইনি। আমি এটা ট্রাম্পকে দিয়েছি।"',
    'medicare.subtext': 'রিপাবলিকান প্রস্তাবে শত শত বিলিয়ন ডলারের মেডিকেয়ার হ্রাস অন্তর্ভুক্ত। প্রতিনিধি Tom Kean Jr. (NJ-7) এই প্রচেষ্টার সাথে যুক্ত হয়েছেন, বয়স্কদের স্বাস্থ্যসেবা হুমকিতে ফেলছেন।',
    'medicare.bullet1': 'GOP বাজেট খসড়ায় মেডিকেয়ারে $৪৭৯ বিলিয়ন কাটার প্রস্তাব করা হয়েছে (পেমেন্ট স্ট্রাকচার, যোগ্যতা পরিবর্তন)।',
    'medicare.bullet2': '"এক বিশাল সুন্দর বিল আইন"-এ মেডিকেয়ার অ্যাক্সেস সীমিত করার বিধান ছিল।',
    'medicare.bullet3': 'NJ-7-এর বয়স্করা হাসপাতাল পরিদর্শন, প্রেসক্রিপশন এবং দীর্ঘমেয়াদী যত্নের জন্য মেডিকেয়ারের উপর নির্ভর করেন।',
    'medicare.cta': 'মেডিকেয়ার রক্ষা করুন — পদক্ষেপ নিন',
    'medicare.visual': 'মেডিকেয়ার = জীবনরেখা।\nপদক্ষেপ নিতে QR কোড স্ক্যান করুন।',

    // Accountability Section
    'accountability.title': 'মুখোশ খুলে গেছে। Tom Kean Jr.-কে জবাবদিহি করুন।',
    'accountability.text': '"কখনও কখনও নীরবতা সোনা নয়। এটা সতর্কতার ছদ্মবেশে কাপুরুষতা।" প্রতিনিধি Tom Kean Jr.-এর (NJ-7) রেকর্ড পরিষ্কার: বেশি খরচ, কম যত্ন, বেশি কষ্ট। NJ-7 আরও ভালো প্রাপ্য।',
    'accountability.cta': '#কিনখোঁজাশুক্রবার-এ যোগ দিন',

    // News Sources Section
    'news.title': '📰 আরও রসিদ',
    'news.updated': '১৩ মার্চ, ২০২৬ আপডেট করা হয়েছে',
    'news.cbs': 'CBS News: কোটি কোটি মানুষ প্রিমিয়াম বৃদ্ধির সম্মুখীন',
    'news.wsj': 'WSJ: মেডিকেয়ার পেমেন্ট স্থির থাকায় বিমা কোম্পানির প্রতিক্রিয়া',
    'news.bloomberg': 'Bloomberg: গ্যাস বা বাজারদরের চেয়ে স্বাস্থ্য ব্যয় বেশি চিন্তা',
    'news.nytimes': 'NY Times: ৪ জন রিপাব্লিকান ভোট জোর করতে দল থেকে বেরিয়ে এসেছে',
    'news.nytimes2': 'NY Times: হাউস ওবামাকেয়ার ভর্তুকি বর্ধন অবরুদ্ধ করেছে',
    'news.nytimes3': 'NY Times: রিপাব্লিকানরা ডেমোক্র্যাটদের প্রস্তাব শেষ পর্যন্ত ঠেলে দিয়েছে',
    'news.cnn': 'CNN: আমেরিকানদের স্বাস্থ্যসেবা খরচ সর্বকালের সর্বোচ্চ',
    'news.nytimes4': 'NY Times: ওবামাকেয়ার স্বাস্থ্য বীমা কাটছাঁট',

    // Footer
    'footer.tagline': 'সত্য কষ্ট দেয়। মিথ্যার দাম বেশি। রিপাবলিকানরা আপনার স্বাস্থ্যসেবার পরোয়া করে না।',
    'footer.hashtags': '#কিনউন্মোচিত #রাজানেই #রিপাবলিকানরাস্বাস্থ্যেরপরোয়াকরেনা',
    'footer.disclaimer': 'সত্য কষ্ট দেয়। মিথ্যার দাম বেশি। রিপাবলিকানরা আপনার স্বাস্থ্যসেবার পরোয়া করে না। #কিনউন্মোচিত #রাজানেই #রিপাবলিকানরাস্বাস্থ্যেরপরোয়াকরেনা',
    'footer.terms': 'ব্যবহারের শর্তাবলী',
    'footer.privacy': 'গোপনীয়তা নীতি',
    'footer.contact': 'যোগাযোগ',
};

export default bn;
